import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
`;

export const SearchBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
  }

  p {
    font-size: 14px;
    color: #666;
  }
`;

export const ResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: calc(100vh - 350px);
  overflow-y: auto;
`;

export const PatientCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  &:hover {
    border-color: #1976d2;
    box-shadow: 0 4px 8px rgba(25, 118, 210, 0.15);
  }
`;

export const PatientInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

export const PatientDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PatientId = styled.span`
  font-size: 12px;
  color: #1976d2;
  font-weight: 600;
  background-color: #e3f2fd;
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
`;

export const PatientName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const PatientCpf = styled.span`
  font-size: 13px;
  color: #666;
`;

export const PatientStatus = styled.span`
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #757575;
  font-weight: 500;
`;

export const MenuButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;

  svg {
    margin-bottom: 15px;
    color: #bdbdbd;
  }

  p {
    font-size: 16px;
    text-align: center;
  }
`;

export const InfoBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 8px;
  border-left: 4px solid #1976d2;

  svg {
    color: #1976d2;
  }

  span {
    font-size: 14px;
    color: #1565c0;
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const AppBadge = styled.div<{ $hasApp: boolean }>`
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.$hasApp ? "#4caf50" : "#ff9800")};
  color: white;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const AccessibilityBadge = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2196f3;
  color: white;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;


